import React from "react";
import "./styles.scss";

import UserAuthMain from "./Component/UserAuth_Main";
import UserAuthExternal from "./Component/UserAuth_External";

const UserAuth = () => {
    const [Page, SetPage] = React.useState(0);
    const render = React.useMemo(() => {
        switch (Page) {
            case 0:
                return <UserAuthMain />;
            case 1:
                return <UserAuthExternal />;
            default:
                return null;
        }
    }, [Page]);
    return (
        <div className="bpl-container">
            <section className={"admin_userAuth"}>
                <div className={"d-flex gap-10 align-center"}>
                    <h3>User Authorization</h3>
                    <div className={"d-flex gap-10"} style={{fontSize: "0.8rem"}}>
                        <button className={`bpl-btn main ${Page === 0 ? "active" : ""}`} onClick={() => SetPage(0)}>User Auth</button>
                        <button className={`bpl-btn primary ${Page === 1 ? "active" : ""}`} onClick={() => SetPage(1)}>External</button>
                    </div>
                </div>
                {render}
            </section>
        </div>
    );
};

export default UserAuth;
